<template>
    <div class="modal fade" id="changePassSuccess" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered ito-popup" role="document" data-bs-backdrop="static"
        data-keyboard=false>
        <div class="modal-content modal-body">

          <div class="close-popup" data-bs-dismiss="modal"></div>
          <div class="modal-success modal-body">
            <h4 class="title">{{ $t('password_updated') }}</h4>

            <img src="/themes/ito/images/get-rewarded.svg" alt="">

            <h6>{{ $t('password_has_been_updated_successfully') }}</h6>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: "ChangePasswordSuccessModal",
}
</script>

<style scoped>

</style>
